export { default } from "./Article";
